import BaseStatus from './BaseStatus';

export class Closed extends BaseStatus { }
Closed.defaultProps = {
    status: "Closed",
    statusColor: "status-closed"
};

export class Available extends BaseStatus { }
Available.defaultProps = {
    status: "Available",
    statusColor: "status-available"
};

export class Unreleased extends BaseStatus { }
Unreleased.defaultProps = {
    status: "Unreleased",
    statusColor: "status-unreleased"
};

export class Reserved extends BaseStatus { }
Reserved.defaultProps = {
    status: "Reserved",
    statusColor: "status-reserved"
};
